import axios from 'axios';

export default async function checkAuth(mob,idToken) {

    return await axios.post( `https://${process.env.REACT_APP_AUTH_ENVIRONMENT}.saveo.in/auth/checkAuth`, {mobileNumber: mob}, {
    headers: {
        Authorization: `Bearer ${idToken}`
    }
    });
}